import {library} from "@fortawesome/fontawesome-svg-core";
import {
    faPlus,
    faEdit,
    faCalendarAlt,
    faTimes
} from "@fortawesome/free-solid-svg-icons";

library.add(faPlus, faEdit, faCalendarAlt, faTimes)